module.exports = __webpack_public_path__ + "img/LocationPoint.d0dd3c0.svg";